import React from "react";
import { SupportHeaderContainer } from "../support/supportElements";

const MdaHeader = ({ heading, subtitle }) => {
  return (
    <SupportHeaderContainer>
      <div className="supportContainer">
        <h2>{heading || "FCT Irs Payment"}</h2>
        <p style={{ fontSize: "18px" }}>
          {subtitle ||
            "Please verify with TIN number to make payment."}
        </p>
      </div>
    </SupportHeaderContainer>
  );
};

export default MdaHeader;
